
import React from 'react';
import { FileText } from 'lucide-react';

const FinanceEmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="rounded-full bg-muted p-3 mb-4">
        <FileText className="h-6 w-6 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-semibold">No procurements pending review</h3>
      <p className="text-muted-foreground mt-2 mb-6 max-w-sm">
        There are no procurement requests waiting for your approval at the moment. New requests will appear here for review.
      </p>
    </div>
  );
};

export default FinanceEmptyState;
